import { Component } from "react";
import {Container } from "reactstrap";
import httpClient from "../../../httpClient";
import { connect } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import AdvencedSearchVols from '../../../components/common/Vols/advancedSearchVols'
import VolFilter from "../../../components/common/Vols/volFilter";
import { redirect } from "../../../slices/filterSlice";
import { withRouter } from "react-router";
import ItinerarieMulti from "../../../components/common/Vols/itinerarie";
import NavTab from '../../../components/common/global_layout/navTab2'



class SearchVol extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vols: [],
      dictionaries: [],
      isLoading: true,
      url:this.props.url,
      depart: new URLSearchParams(this.props.location.search).get("depart"),
      arrive:  new URLSearchParams(this.props.location.search).get("arrive"),
      origin : new URLSearchParams(this.props.location.search).get("origin"),
      destination : new URLSearchParams(this.props.location.search).get("destination")
    };
  }

  componentDidUpdate(prevProps, prevState){
    const {depart,arrive,origin,destination} = this.state;
     if(this.props.redirectBool===true && prevProps.url !== this.props.url){
      this.props.dispatch(redirect(false))
      const rootLink = `/vols/search`
      const restLink = `?multi=${this.props.volType}&return=${this.props.return}&depart=${depart}&arrive=${arrive}&origin=${origin}&destination=${destination}&date_depart=${this.props.startDate}&date_arrive=${this.props.endDate}&`
      const newUrl = rootLink+restLink
      this.props.history.push(newUrl+this.props.url)
      this.setState({
        vols: [],
        isLoading: true,
      });
      this.vols(restLink+this.props.url);
     }
  }
  componentDidMount(){
     this.vols();
  }
  async vols(url) {
    var params = new URLSearchParams(url || this.props.location.search);
     let vols = await httpClient.getSearchedVols(params,this.props.volType)
     this.setState({
       vols:vols,
       isLoading: false,
     })
  }

  render() {
    let url = new URLSearchParams(this.props.location.search);
    const volRes = this.state.vols;

    return (
      <>
        <Container>
        <NavTab />
          
          <AdvencedSearchVols />
        
      
          <div className="container row d-flex justify-content-between mt-4 pr-0">
              <div className="col-3">
                <VolFilter/>
              </div>
              <div className="col-9 pr-0">
                 {this.state.isLoading && (
                    <center className="loader-heberg">
                      <ClipLoader
                        color={"#37296a"}
                        loading={this.state.isLoading}
                        size={50}
                      />
                    </center>
                  )}
                  <ItinerarieMulti volRes={volRes} url={url}/>
              </div>
            
               
       
          </div>
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    url: state.filter.url,
    startDate: state.date.startDate,
    endDate: state.date.endDate,
    redirectBool : state.filter.redirectBool,
    volType:state.volBarFilter.multiDest,
    return : state.volBarFilter.volReturn

  };
}
//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(SearchVol));